module.exports = __webpack_public_path__ + "img/78853.53cadb4c.svg";